import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../features/slices/applicationSlice";
import { TFunction } from "i18next";

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showConfirmCreateAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.create.title'),
                message: translate('alerts.create.message'),
                icon: 'info',
                confirmText: translate('alerts.create.confirmText'),
                cancelText: translate('alerts.create.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction
            })
        );
    };

    const showConfirmEditAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.edit.title'),
                message: translate('alerts.edit.message'),
                icon: 'info',
                confirmText: translate('alerts.edit.confirmText'),
                cancelText: translate('alerts.edit.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    const showConfirmDeleteAlert = ({ confirmAction, cancelAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.delete.title'),
                message: translate('alerts.delete.message'),
                icon: 'error',
                confirmText: translate('alerts.delete.confirmText'),
                cancelText: translate('alerts.delete.cancelText'),
                confirmAction: confirmAction,
                cancelAction: cancelAction || null
            })
        );
    };

    return { showConfirmCreateAlert, showConfirmEditAlert, showConfirmDeleteAlert };
};

export default useAlerts;